const JAPAN_POSTAL_CODE_REGEXP = /(\d{7})|(\d{3}-\d{4})/;

export function extractJapanPostalCode(text: string): string | undefined {
  return text.match(JAPAN_POSTAL_CODE_REGEXP)?.[0];
}
